import { css } from '@/styled-system/css';

export const dropdownBodyStyles = css.raw({
  'paddingBlock': 'default',
  'paddingInline': 'default',
  'overflowY': 'auto',
  'flexGrow': 1,
  'flexShrink': 1,
  'flexBasis': 'auto',

  '& > [data-c11n-component="Dropdown.Heading"]:first-child': {
    borderStartStartRadius: 'obj.soft',
    borderStartEndRadius: 'obj.soft',
    marginBlockStart: 'calc(-1 * {spacing.default})',
  },

  '& > [data-c11n-component="Dropdown.Heading"]': {
    marginInline: 'calc(-1 * {spacing.default})',
  },
});
